import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Feed as FeedIcon,
  Group as GroupIcon,
  Person as PersonIcon,
} from '@mui/icons-material';

const MobileBottomNav: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on desktop
  if (!isMobile) {
    return null;
  }

  // Determine current value based on pathname
  const getCurrentValue = () => {
    if (location.pathname === '/feed') return 0;
    if (location.pathname === '/clubs') return 1;
    if (location.pathname === '/profile') return 2;
    return 0;
  };

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/feed');
        break;
      case 1:
        navigate('/clubs');
        break;
      case 2:
        navigate('/profile');
        break;
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
      }}
      elevation={3}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={handleChange}
        showLabels
        sx={{
          height: 64,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 12px',
          },
          '& .Mui-selected': {
            color: 'primary.main',
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.75rem',
              fontWeight: 600,
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.7rem',
          },
        }}
      >
        <BottomNavigationAction
          label="Feed"
          icon={<FeedIcon />}
        />
        <BottomNavigationAction
          label="Clubs"
          icon={<GroupIcon />}
        />
        <BottomNavigationAction
          label="Profile"
          icon={<PersonIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav;
